import React, { useState } from 'react'
import Header from '../Header/Header'
import CustomHeading from '../../components/common/CustomHeading'

const AnalyticsPage = () => {
  const [selectedPeriod, setSelectedPeriod] = useState('month');
  const [selectedMetric, setSelectedMetric] = useState('Count Wise');

  // Mock data for analytics
  const analyticsData = {
    totalProperties: 145,
    activeProperties: 98,
    pendingProperties: 23,
    completedProperties: 24,
    totalValue: '₹12.5 Cr',
    avgPropertyValue: '₹8.6 L'
  };

  const periods = [
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: 'quarter', label: 'This Quarter' },
    { value: 'year', label: 'This Year' }
  ];

  const metrics = ['Count Wise', 'Value Wise'];
  const dateRanges = ['Jan 01 - Dec 31', 'Apr 01 - Mar 31', 'Custom Range'];

  // Mock team performance data
  const teamData = [
    { name: 'Ram Chauran', total: 250, dropped: 120, confirmed: 200 },
    { name: 'User 2', total: 300, dropped: 150, confirmed: 250 },
    { name: 'User 3', total: 120, dropped: 50, confirmed: 100 },
    { name: 'User 4', total: 240, dropped: 130, confirmed: 200 },
    { name: 'User 5', total: 400, dropped: 200, confirmed: 330 },
    { name: 'User 6', total: 240, dropped: 120, confirmed: 200 },
    { name: 'User 7', total: 20, dropped: 10, confirmed: 15 },
    { name: 'User 8', total: 25, dropped: 12, confirmed: 20 },
    { name: 'User 9', total: 250, dropped: 130, confirmed: 200 },
    { name: 'User 10', total: 240, dropped: 130, confirmed: 200 },
    { name: 'User 11', total: 250, dropped: 140, confirmed: 200 },
    { name: 'User 12', total: 240, dropped: 130, confirmed: 200 }
  ];

  return (
    <div className="bg-gray-50 min-h-screen">
      <Header/>
      <div className='pt-28 px-6 pb-10'>
        {/* Header Section */}
        <div className="flex items-center justify-between mb-8">
          <CustomHeading title="Analytics" textColor={"primary"}/>
          
          {/* Time Period Selector */}
          {/* <div className="flex bg-white rounded-lg shadow-sm border">
            {periods.map((period) => (
              <button
                key={period.value}
                onClick={() => setSelectedPeriod(period.value)}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
                  selectedPeriod === period.value
                    ? 'bg-customGreen text-white shadow-sm'
                    : 'text-gray-600 hover:text-customGreen hover:bg-gray-50'
                }`}
              >
                {period.label}
              </button>
            ))}
          </div> */}
        </div>

        {/* Analytics Cards */}
        {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8"> */}
          {/* Total Properties Card */}
          {/* <div className="bg-white rounded-xl shadow-sm border p-6 hover:shadow-md transition-shadow duration-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Total Properties</p>
                <p className="text-3xl font-bold text-gray-900 mt-2">{analyticsData.totalProperties}</p>
              </div>
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
            </div>
            <div className="mt-4 flex items-center text-sm">
              <span className="text-green-600 font-medium">+12%</span>
              <span className="text-gray-500 ml-1">from last period</span>
            </div>
          </div> */}

          {/* Active Properties Card */}
          {/* <div className="bg-white rounded-xl shadow-sm border p-6 hover:shadow-md transition-shadow duration-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Active Properties</p>
                <p className="text-3xl font-bold text-gray-900 mt-2">{analyticsData.activeProperties}</p>
              </div>
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
            <div className="mt-4 flex items-center text-sm">
              <span className="text-green-600 font-medium">+8%</span>
              <span className="text-gray-500 ml-1">from last period</span>
            </div>
          </div> */}

          {/* Pending Properties Card */}
          {/* <div className="bg-white rounded-xl shadow-sm border p-6 hover:shadow-md transition-shadow duration-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Pending Properties</p>
                <p className="text-3xl font-bold text-gray-900 mt-2">{analyticsData.pendingProperties}</p>
              </div>
              <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center">
                <svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
            <div className="mt-4 flex items-center text-sm">
              <span className="text-yellow-600 font-medium">-5%</span>
              <span className="text-gray-500 ml-1">from last period</span>
            </div>
          </div> */}

          {/* Total Value Card */}
          {/* <div className="bg-white rounded-xl shadow-sm border p-6 hover:shadow-md transition-shadow duration-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Total Value</p>
                <p className="text-3xl font-bold text-gray-900 mt-2">{analyticsData.totalValue}</p>
              </div>
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                </svg>
              </div>
            </div>
            <div className="mt-4 flex items-center text-sm">
              <span className="text-green-600 font-medium">+18%</span>
              <span className="text-gray-500 ml-1">from last period</span>
            </div>
          </div> */}

          {/* Average Property Value Card */}
          {/* <div className="bg-white rounded-xl shadow-sm border p-6 hover:shadow-md transition-shadow duration-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Avg Property Value</p>
                <p className="text-3xl font-bold text-gray-900 mt-2">{analyticsData.avgPropertyValue}</p>
              </div>
              <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center">
                <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v4a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
            </div>
            <div className="mt-4 flex items-center text-sm">
              <span className="text-green-600 font-medium">+3%</span>
              <span className="text-gray-500 ml-1">from last period</span>
            </div>
          </div> */}

          {/* Completed Properties Card */}
          {/* <div className="bg-white rounded-xl shadow-sm border p-6 hover:shadow-md transition-shadow duration-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Completed Properties</p>
                <p className="text-3xl font-bold text-gray-900 mt-2">{analyticsData.completedProperties}</p>
              </div>
              <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center">
                <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
            <div className="mt-4 flex items-center text-sm">
              <span className="text-green-600 font-medium">+15%</span>
              <span className="text-gray-500 ml-1">from last period</span>
            </div>
          </div> */}
        {/* </div> */}

        {/* Property Procurement Team Performance Chart */}
        <div className="bg-white rounded-xl shadow-sm border p-6 mb-6">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center space-x-4">
              <h3 className="text-xl font-semibold text-gray-900">Property Procurement Team Performance</h3>
              
              {/* Legend */}
              <div className="flex items-center space-x-6">
                <div className="flex items-center space-x-2">
                  <div className="w-4 h-4 bg-blue-500 rounded"></div>
                  <span className="text-sm text-gray-600">450 Total Properties</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-4 h-4 bg-red-500 rounded"></div>
                  <span className="text-sm text-gray-600">250 Dropped</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-4 h-4 bg-green-500 rounded"></div>
                  <span className="text-sm text-gray-600">250 Confirmed Listed</span>
                </div>
              </div>
            </div>
            
            {/* Controls */}
            <div className="flex items-center space-x-4">
              {/* Metric Selector */}
              <select 
                value={selectedMetric}
                onChange={(e) => setSelectedMetric(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-customGreen"
              >
                {metrics.map(metric => (
                  <option key={metric} value={metric}>{metric}</option>
                ))}
              </select>
              
              {/* Date Range Selector */}
              <select className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-customGreen">
                {dateRanges.map(range => (
                  <option key={range} value={range}>{range}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Chart Area */}
          <div className="relative">
            <div className="h-80 flex items-end justify-between space-x-2 px-4 border-b border-l border-gray-200">
              {/* Y-axis labels */}
              <div className="absolute left-0 h-full flex flex-col justify-between text-xs text-gray-500 -ml-8">
                <span>400</span>
                <span>300</span>
                <span>200</span>
                <span>100</span>
                <span>0</span>
              </div>

              {/* Right Y-axis labels */}
              <div className="absolute right-0 h-full flex flex-col justify-between text-xs text-gray-500 -mr-8">
                <span>10k₹</span>
                <span>8k₹</span>
                <span>6k₹</span>
                <span>4k₹</span>
                <span>2k₹</span>
                <span>0</span>
              </div>

              {teamData.map((user, index) => {
                const maxHeight = 320; // 80 * 4 (h-80 = 320px)
                const maxValue = 400;
                
                return (
                  <div key={user.name} className="flex flex-col items-center space-y-1 flex-1 max-w-20">
                    {/* Bars */}
                    <div className="flex items-end space-x-1 h-72">
                      {/* Total Properties Bar */}
                      <div 
                        className="bg-blue-500 w-4 rounded-t"
                        style={{ 
                          height: `${(user.total / maxValue) * 288}px`,
                          minHeight: user.total > 0 ? '8px' : '0px'
                        }}
                      />
                      {/* Dropped Bar */}
                      <div 
                        className="bg-red-500 w-4 rounded-t"
                        style={{ 
                          height: `${(user.dropped / maxValue) * 288}px`,
                          minHeight: user.dropped > 0 ? '8px' : '0px'
                        }}
                      />
                      {/* Confirmed Bar */}
                      <div 
                        className="bg-green-500 w-4 rounded-t"
                        style={{ 
                          height: `${(user.confirmed / maxValue) * 288}px`,
                          minHeight: user.confirmed > 0 ? '8px' : '0px'
                        }}
                      />
                    </div>
                    
                    {/* User Name */}
                    <div className="text-xs text-gray-600 text-center leading-tight">
                      <div>{user.name.split(' ')[0]}</div>
                      {user.name.split(' ')[1] && <div>{user.name.split(' ')[1]}</div>}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Highlighted user indicator */}
            <div className="absolute top-4 right-1/3 bg-blue-500 text-white px-3 py-1 rounded-full text-sm">
              220 Property
            </div>

            {/* Coming Soon Overlay */}
            <div className="absolute inset-0 bg-gray-50 bg-opacity-90 flex items-center justify-center rounded-lg">
              <div className="text-center">
                <div className="inline-flex items-center px-6 py-3 bg-orange-100 border border-orange-300 rounded-full">
                  <svg className="w-5 h-5 text-orange-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="text-orange-700 font-medium text-sm">Interactive Charts Coming Soon</span>
                </div>
                <p className="text-gray-500 text-sm mt-2">Advanced analytics and filtering will be available shortly</p>
              </div>
            </div>
          </div>
        </div>

        {/* Charts Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Property Status Chart */}
          {/* <div className="bg-white rounded-xl shadow-sm border p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Property Status Distribution</h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                  <span className="text-gray-600">Active</span>
                </div>
                <span className="text-gray-900 font-medium">67.6%</span>
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                  <span className="text-gray-600">Pending</span>
                </div>
                <span className="text-gray-900 font-medium">15.9%</span>
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                  <span className="text-gray-600">Completed</span>
                </div>
                <span className="text-gray-900 font-medium">16.5%</span>
              </div>
            </div>
            <div className="mt-6 text-center">
              <div className="inline-flex items-center px-4 py-2 bg-gray-100 border border-gray-300 rounded-full">
                <span className="text-gray-600 font-medium text-sm">Pie Chart Coming Soon</span>
              </div>
            </div>
          </div> */}

          {/* Monthly Trend Chart */}
          {/* <div className="bg-white rounded-xl shadow-sm border p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Monthly Trend</h3>
            <div className="h-48 flex items-center justify-center border-2 border-dashed border-gray-200 rounded-lg">
              <div className="text-center">
                <svg className="w-12 h-12 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v4a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
                <div className="inline-flex items-center px-4 py-2 bg-gray-100 border border-gray-300 rounded-full">
                  <span className="text-gray-600 font-medium text-sm">Line Chart Coming Soon</span>
                </div>
              </div>
            </div>
          </div> */}
        </div>

        {/* Recent Activities */}
        {/* <div className="mt-6 bg-white rounded-xl shadow-sm border p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Recent Property Activities</h3>
          <div className="space-y-4">
            <div className="flex items-center space-x-4 p-3 bg-gray-50 rounded-lg">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <div className="flex-1">
                <p className="text-sm font-medium text-gray-900">New property added: Luxury Villa in Gurgaon</p>
                <p className="text-xs text-gray-500">2 hours ago</p>
              </div>
            </div>
            <div className="flex items-center space-x-4 p-3 bg-gray-50 rounded-lg">
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
              <div className="flex-1">
                <p className="text-sm font-medium text-gray-900">Property status updated: Apartment Complex</p>
                <p className="text-xs text-gray-500">4 hours ago</p>
              </div>
            </div>
            <div className="flex items-center space-x-4 p-3 bg-gray-50 rounded-lg">
              <div className="w-2 h-2 bg-yellow-500 rounded-full"></div>
              <div className="flex-1">
                <p className="text-sm font-medium text-gray-900">Legal analysis completed for Commercial Plot</p>
                <p className="text-xs text-gray-500">6 hours ago</p>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  )
}

export default AnalyticsPage
